import React from 'react';
import { Row } from 'antd';
import cs from 'classnames';

export default ({ style, id, className, children }) => (
	<Row id={id} className={cs('BlockWrapper', className)}>
		{children}
	</Row>
);



// WEBPACK FOOTER //
// ./src/components/LandingBlockWrapper/BlockWrapper.js